<template>
  <ValidationObserver slim v-slot="{ invalid }">
    <div class="md-layout">
      <div class="md-layout-item md-size-60 md-medium-size-100">
        <md-card id="client-card">
          <md-card-header class="md-card-header-icon md-card-header-brand">
            <div class="card-icon">
              <md-icon>assignment</md-icon>
            </div>
            <h4 class="title">Klijent</h4>
            <md-button
              class="md-just-icon md-round modal-default-button md-simple"
              @click="hideClient"
            >
              <md-icon style="color: red">clear</md-icon>
            </md-button>
          </md-card-header>
          <md-card-content class="md-layout">
            <ValidationProviderExtended
              :name="client.type === 'store' ? 'Naziv' : 'Ime i prezime'"
              rules="between:2,100"
              className="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
            >
              <label>
                {{ client.type === 'store' ? 'Naziv' : 'Ime i prezime' }}
              </label>
              <md-input v-model="client.name" type="text"> </md-input>
            </ValidationProviderExtended>
            <ValidationProviderExtended
              name="Adresa"
              rules="required|between:2,200"
              className="md-layout-item md-size-20 md-large-size-50 md-small-size-100"
            >
              <label>Adresa</label>
              <md-input v-model="client.address" type="text"> </md-input>
            </ValidationProviderExtended>

            <ValidationProviderExtended
              name="Grad"
              rules="required|between:2,100"
              className="md-layout-item md-size-15 md-large-size-50 md-small-size-100"
            >
              <label>Grad</label>
              <md-input v-model="client.city" type="text"> </md-input>
            </ValidationProviderExtended>

            <ValidationProviderExtended
              name="Država"
              rules="required"
              className="md-layout-item md-size-15 md-large-size-50 md-small-size-100"
            >
              <label> Država </label>
              <md-select v-model="client.country">
                <md-option
                  v-for="(option, index) in countries"
                  :key="index"
                  :value="option.alpha3Code"
                  >{{ option.name }}</md-option
                >
              </md-select>
            </ValidationProviderExtended>

            <md-field
              class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
            >
              <md-radio v-model="client.type" value="store"> Firma </md-radio>
              <md-radio v-model="client.type" value="person">
                Fizičko Lice
              </md-radio>
              <md-radio v-model="client.type" value="perm_contact_calendar">
                Radnik
              </md-radio>
            </md-field>

            <div
              v-if="client.type === 'store'"
              class="md-layout md-layout-item md-size-100"
            >
              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label> PDV broj </label>
                <md-input v-model="client.pdvCode" type="text"> </md-input>
              </md-field>
              <ValidationProviderExtended
                name="PIB"
                rules="required|regex:^\d{8}$"
                className="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label> PIB </label>
                <md-input v-model="client.pib" type="text"> </md-input>
              </ValidationProviderExtended>
              <md-field
                class="md-layout-item md-size-50 md-large-size-50 md-small-size-100"
              >
                <div class="md-layout-item md-size-50">
                  <md-checkbox v-model="client.isClient"> Kupac </md-checkbox>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-checkbox v-model="client.isSeller">
                    Dobavljač
                  </md-checkbox>
                </div>
              </md-field>
              <md-field
                class="md-layout-item md-size-50 md-large-size-50 md-small-size-100"
              >
                <label>Email</label>
                <md-input v-model="client.email" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-50 md-large-size-50 md-small-size-100"
              >
                <label>Website</label>
                <md-input v-model="client.website" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label>Kontakt 1</label>
                <md-input v-model="client.contact1" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label>Kontakt 2</label>
                <md-input v-model="client.contact2" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label>Kontakt 3</label>
                <md-input v-model="client.contact3" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label>Kontakt 4</label>
                <md-input v-model="client.contact4" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-50 md-large-size-50 md-small-size-100"
              >
                <label>Žiro Račun 1</label>
                <md-input v-model="client.bankAccount1" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-50 md-large-size-50 md-small-size-100"
              >
                <label>Žiro Račun 2</label>
                <md-input v-model="client.bankAccount2" type="text"> </md-input>
              </md-field>
            </div>

            <div
              v-if="client.type === 'person'"
              class="md-layout md-layout-item md-size-100"
            >
              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label> JMBG </label>
                <md-input v-model="client.pib" type="text"> </md-input>
              </md-field>

              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label>Datum rodjenja</label>
                <md-datepicker v-model="client.dateOfBirth" />
              </md-field>

              <md-field
                class="md-layout-item md-size-50 md-large-size-50 md-small-size-100"
              >
                <div class="md-layout-item md-size-50">
                  <md-checkbox v-model="client.isClient"> Kupac </md-checkbox>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-checkbox v-model="client.isSeller">
                    Dobavljač
                  </md-checkbox>
                </div>
              </md-field>
              <md-field
                class="md-layout-item md-size-50 md-large-size-50 md-small-size-100"
              >
                <label>Email</label>
                <md-input v-model="client.email" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-50 md-large-size-50 md-small-size-100"
              >
                <label>Website</label>
                <md-input v-model="client.website" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label>Kontakt 1</label>
                <md-input v-model="client.contact1" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label>Kontakt 2</label>
                <md-input v-model="client.contact2" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label>Kontakt 3</label>
                <md-input v-model="client.contact3" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label>Kontakt 4</label>
                <md-input v-model="client.contact4" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-50 md-large-size-50 md-small-size-100"
              >
                <label>Žiro Račun 1</label>
                <md-input v-model="client.bankAccount1" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-50 md-large-size-50 md-small-size-100"
              >
                <label>Žiro Račun 2</label>
                <md-input v-model="client.bankAccount2" type="text"> </md-input>
              </md-field>
            </div>

            <div
              v-if="client.type === 'perm_contact_calendar'"
              class="md-layout md-layout-item md-size-100"
            >
              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label> JMBG </label>
                <md-input v-model="client.pib" type="text"> </md-input>
              </md-field>

              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label>Datum rodjenja</label>
                <md-datepicker v-model="client.dateOfBirth" />
              </md-field>

              <md-field
                class="md-layout-item md-size-50 md-large-size-50 md-small-size-100"
              >
                <div class="md-layout-item md-size-50">
                  <md-checkbox v-model="client.isClient"> Kupac </md-checkbox>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-checkbox v-model="client.isSeller">
                    Dobavljač
                  </md-checkbox>
                </div>
              </md-field>
              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label>Email</label>
                <md-input v-model="client.email" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label>Kontakt</label>
                <md-input v-model="client.contact1" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-20 md-large-size-50 md-small-size-100"
              >
                <label>Datum zaposlenja</label>
                <md-datepicker v-model="client.dateOfHire" />
              </md-field>
              <md-field
                class="md-layout-item md-size-20 md-large-size-50 md-small-size-100"
              >
                <label>Datum prestanka</label>
                <md-datepicker v-model="client.dateOfFire" />
              </md-field>
              <div class="md-layout-item md-size-10">
                <p class="tim-note">
                  {{ yearsOfService ? yearsOfService : '' }}
                </p>
              </div>

              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label>Radno mjesto</label>
                <md-input v-model="client.role" type="text"> </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
              >
                <label>Smjena</label>
                <md-select v-model="client.shiftId">
                  <md-option
                    v-for="(option, index) in shifts"
                    :key="index"
                    :value="option.id"
                    >{{ option.name }}</md-option
                  >
                </md-select>
              </md-field>
              <md-field
                class="md-layout-item md-size-20 md-large-size-50 md-small-size-100"
              >
                <label>Plata na računu €</label>
                <md-input
                  v-model="client.salary"
                  type="number"
                  step="0.01"
                  min="0.01"
                >
                </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-20 md-large-size-50 md-small-size-100"
              >
                <label>Plata u gotovini €</label>
                <md-input
                  v-model="client.salaryCash"
                  type="number"
                  step="0.01"
                  min="0.01"
                >
                </md-input>
              </md-field>
              <md-field
                class="md-layout-item md-size-10 md-large-size-50 md-small-size-100"
              >
                <label>Godišnji odmor</label>
                <md-input
                  v-model="client.vacationDays"
                  type="number"
                  step="1"
                  min="0"
                >
                </md-input>
              </md-field>
            </div>

            <md-field class="md-layout-item md-size-100 md-small-size-100">
              <label> Komentar </label>
              <md-textarea v-model="client.comment"> </md-textarea>
            </md-field>
          </md-card-content>
          <md-card-actions md-alignment="right">
            <md-button
              class="md-success"
              @click="saveClient"
              :disabled="invalid"
            >
              <md-icon> save </md-icon>
              Sačuvaj
            </md-button>
          </md-card-actions>
        </md-card>
      </div>

      <div
        v-if="client.type === 'store'"
        class="md-layout-item md-size-40 md-medium-size-100"
      >
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-brand">
            <div class="card-icon">
              <md-icon>people</md-icon>
            </div>
            <h4 class="title">Kontakt osobe</h4>
          </md-card-header>
          <md-card-content>
            <md-table
              id="contactPersonTable"
              v-model="client.contactPersons"
              class="table-striped contact-persons-table"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ime">
                  <md-field>
                    <md-input v-model="item.name" type="text"> </md-input>
                  </md-field>
                </md-table-cell>
                <md-table-cell md-label="Email">
                  <md-field>
                    <md-input v-model="item.email" type="text"> </md-input>
                  </md-field>
                </md-table-cell>
                <md-table-cell md-label="Kontakt">
                  <md-field>
                    <md-input v-model="item.contact1" type="text"> </md-input>
                  </md-field>
                </md-table-cell>
                <md-table-cell md-label="Kontakt">
                  <md-field>
                    <md-input v-model="item.contact2" type="text"> </md-input>
                  </md-field>
                </md-table-cell>
                <md-table-cell md-label="Kontakt">
                  <md-field>
                    <md-input v-model="item.contact3" type="text"> </md-input>
                  </md-field>
                </md-table-cell>
                <md-table-cell md-label="Briši">
                  <md-button
                    class="md-just-icon md-danger md-simple"
                    @click.native="deletePerson(item)"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
          <md-card-actions md-alignment="left">
            <md-button @click="addPerson" class="md-info"> Dodaj + </md-button>
          </md-card-actions>
        </md-card>
      </div>

      <div
        v-else-if="client.type === 'perm_contact_calendar'"
        class="md-layout-item md-size-40 md-medium-size-100"
      >
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-brand">
            <div class="card-icon">
              <md-icon>calendar_view_month</md-icon>
            </div>
            <h4 class="title">Odsustva</h4>
          </md-card-header>
          <md-card-content>
            <md-table
              id="leavesTable"
              v-model="client.leaves"
              class="table-striped contact-persons-table"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Broj">
                  {{ item.id }}
                </md-table-cell>
                <md-table-cell md-label="Početak">
                  {{ item.start }}
                </md-table-cell>
                <md-table-cell md-label="Kraj">
                  {{ item.end }}
                </md-table-cell>
                <md-table-cell md-label="Dana">
                  {{ item.difference }}
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
          <md-card-actions class="md-layout evenly-actions">
            <md-button
              @click="addLeave"
              class="md-info md-layout-item md-size-15"
            >
              Dodaj odsustvo +
            </md-button>
            <md-field
              class="md-layout-item md-size-20 md-large-size-50 md-small-size-100"
            >
              <label>Datum Početka</label>
              <md-datepicker v-model="vacationStart" />
            </md-field>
            <md-field
              class="md-layout-item md-size-20 md-large-size-50 md-small-size-100"
            >
              <label>Datum Kraja</label>
              <md-datepicker v-model="vacationEnd" />
            </md-field>
          </md-card-actions>
        </md-card>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import services from '@/api/services';
import api from '@/api/api.js';
import ValidationProviderExtended from '@/components/ValidationProviderExtended.vue';
import { getAsDate, cases } from '@/utils/helpers';
export default {
  props: {
    client: Object,
  },
  components: {
    ValidationProviderExtended,
  },
  computed: {
    yearsOfService() {
      let years;
      if (this.client.dateOfHire === null) {
        return null;
      } else if (this.client.dateOfFire === null) {
        years = Math.floor(
          (new Date().getTime() - new Date(this.client.dateOfHire).getTime()) /
            (1000 * 60 * 60 * 24 * 364),
        );
      } else {
        years = Math.floor(
          (new Date(this.client.dateOfFire).getTime() -
            new Date(this.client.dateOfHire).getTime()) /
            (1000 * 60 * 60 * 24 * 364),
        );
      }

      return years + cases(years, 'Godina', 'Godine', 'Godina') + '  staža';
    },
  },
  data() {
    return {
      shifts: null,
      vacationStart: null,
      vacationEnd: null,
      countries: null,
    };
  },
  methods: {
    addPerson() {
      this.client.contactPersons.push({
        id: null,
        name: null,
        email: null,
        contact1: null,
        contact2: null,
        contact3: null,
      });
    },
    addLeave() {
      const id =
        (this.client.leaves.length
          ? this.client.leaves[this.client.leaves.length - 1].id
          : 0) + 1;
      const days = Math.floor(
        (new Date(this.vacationEnd).getTime() -
          new Date(this.vacationStart).getTime()) /
          (1000 * 60 * 60 * 24),
      );
      // days = Math.floor(days / 7) * 5 + (Math.min(5, days % 7))
      this.client.leaves.push({
        id,
        start: getAsDate(this.vacationStart),
        end: getAsDate(this.vacationEnd),
        difference: days,
      });
    },
    deletePerson(person) {
      this.client.contactPersons = this.client.contactPersons.filter(
        (contactPerson) => contactPerson.id !== person.id,
      );
    },
    hideClient() {
      this.$emit('hideClient', true);
    },
    saveClient() {
      const client = {
        id: this.client.id,
        name: this.client.name,
        address: this.client.address,
        city: this.client.city,
        country: this.client.country,
        type: this.client.type,
        isClient: this.client.isClient,
        isSeller: this.client.isSeller,
        pib: this.client.pib,
        email: this.client.email,
        comment: this.client.comment,
        contact1: this.client.contact1,
      };
      if (client.type === 'store' || client.type === 'person') {
        Object.assign(client, {
          pdvCode: this.client.pdvCode,
          contact2: this.client.contact2,
          contact3: this.client.contact3,
          contact4: this.client.contact4,
          bankAccount1: this.client.bankAccount1,
          bankAccount2: this.client.bankAccount2,
        });
      }

      if (client.type === 'store') {
        Object.assign(client, {
          pib: this.client.pib,
          contactPersons: this.client.contactPersons,
        });
      }

      if (client.type === 'person' || client.type === 'perm_contact_calendar') {
        Object.assign(client, {
          dateOfBirth: this.client.dateOfBirth,
        });
      }

      if (client.type === 'perm_contact_calendar') {
        Object.assign(client, {
          dateOfHire: this.client.dateOfHire,
          dateOfFire: this.client.dateOfFire,
          shiftId: this.client.shiftId,
          role: this.client.role,
          salary: this.client.salary,
          salaryCash: this.client.salaryCash,
          vacationDays: this.client.vacationDays,
          leaves: this.client.leaves,
        });
      }

      api
        .post(services.clients.setClient, {
          setClient: true,
          client: JSON.stringify(client),
        })
        .then((data) => {
          this.$notify({
            timeout: 2500,
            message: 'Ažuriran klijent ' + this.client.name,
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'success',
          });
          if (data.id && this.$route.query.id !== data.id) {
            this.client.id = data.id;
            this.$router.push({ path: 'clients', query: { id: data.id } });
          }
          this.$emit('saveClient', true);
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    getShifts() {
      api
        .get(services.getShifts, { loadShifts: true })
        .then((data) => {
          this.shifts = data;
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
  },
  mounted() {
    // this.$refs.contactPersonTable.style.height = '300px'
    this.getShifts();
    api
      .get(services.getCountries, { getCountries: true })
      .then((data) => {
        this.countries = data;
      })
      .catch((error) => {
        this.alertError(error);
      });
    document.getElementById('contactPersonTable').style.maxHeight =
      document.getElementById('client-card').clientHeight - 105 + 'px';
  },
  watch: {
    'client.dateOfBirth': {
      handler(to) {
        getAsDate(to);
      },
    },
  },
};
</script>

<style scoped>
.contact-persons-table {
  /* max-height: 300px; */
  overflow-y: auto;
}
.tim-note {
  margin: 20px 0px;
}
.evenly-actions {
  justify-content: space-evenly;
}
</style>
